import { render } from "./CartTable.vue?vue&type=template&id=5b024712&scoped=true"
import script from "./CartTable.vue?vue&type=script&lang=js"
export * from "./CartTable.vue?vue&type=script&lang=js"

import "./CartTable.vue?vue&type=style&index=0&id=5b024712&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b024712"]])

export default __exports__